"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
__exportStar(require("./documents"), exports);
__exportStar(require("./entity"), exports);
__exportStar(require("./footer"), exports);
__exportStar(require("./header"), exports);
__exportStar(require("./translation"), exports);
__exportStar(require("./investors-menu"), exports);
//# sourceMappingURL=index.js.map